'use strict';

var getProductAvailabilityLabel$1 = require('../../../../../../../../_virtual/getProductAvailabilityLabel.cjs');
require('../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
require('../types/availabilityStatus.cjs');
var availabilityStatus$1 = require('../../../../../../../../_virtual/availabilityStatus.cjs');
var index$1 = require('../../../../../../../../_virtual/index3.cjs');

var index = index$1.__exports;
var availabilityStatus = availabilityStatus$1.__exports;

/**
 * Returns the availability label text based on the availability status.
 */ const getProductAvailabilityLabel = (availabilityStatus$1)=>{
    let availabilityLabelText = "";
    let availabilityStatusIcon;
    switch(availabilityStatus$1){
        case availabilityStatus.AvailabilityStatus.backordered:
            availabilityLabelText = "Backordered";
            availabilityStatusIcon = index.faClock;
            break;
        case availabilityStatus.AvailabilityStatus.discontinued:
            availabilityLabelText = "Discontinued";
            availabilityStatusIcon = index.faBan;
            break;
        case availabilityStatus.AvailabilityStatus.to_be_discontinued:
            availabilityLabelText = "To be discontinued";
            availabilityStatusIcon = index.faBan;
            break;
        case availabilityStatus.AvailabilityStatus.unavailable:
        case availabilityStatus.AvailabilityStatus.na:
            availabilityLabelText = "Out of stock";
            availabilityStatusIcon = index.faExclamationCircle;
            break;
        default:
            availabilityLabelText = "";
    }
    return {
        availabilityLabelText,
        availabilityStatusIcon
    };
};

getProductAvailabilityLabel$1.__exports.getProductAvailabilityLabel = getProductAvailabilityLabel;

module.exports = getProductAvailabilityLabel$1.__exports;
//# sourceMappingURL=getProductAvailabilityLabel.cjs.map
